<div class="c-form__element">
  <label class="c-form__label" [for]="inputId">{{label}}</label>
  @if (datePickerOptionsDate.startView === 'date') {
    <p-datepicker [inputId]="inputId" [(ngModel)]="date" (ngModelChange)="onChangeDate()" [dateFormat]="datePickerOptionsDate.format" view="date" [showIcon]="true" [iconDisplay]="'input'"
      [minDate]="datePickerOptionsDate.startDate" [maxDate]="datePickerOptionsDate.endDate" [placeholder]="datePickerOptionsDate.placeholder" appendTo="body"
      [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [touchUI]="isMobile"
      (onClose)="onPickerClosed()" (onClickOutside)="onPickerClosed()">
    </p-datepicker>
  } @else {
    <p-datepicker [inputId]="inputId" [(ngModel)]="date" (ngModelChange)="onChangeDate()" [dateFormat]="datePickerOptionsDate.format" view="month" [showIcon]="true" [iconDisplay]="'input'"
      [minDate]="datePickerOptionsDate.startDate" [maxDate]="datePickerOptionsDate.endDate" [placeholder]="datePickerOptionsDate.placeholder" appendTo="body"
      [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [touchUI]="isMobile"
      (onClose)="onPickerClosed()" (onClickOutside)="onPickerClosed()">
    </p-datepicker>
  }
</div>
